/**
 * Error helpers for the notification bell's inline-reply composer.
 *
 * `POST /roster/{entry_id}/threads/{type}/messages` returns HTTP 423 when the
 * thread has since been locked (lock state can drift after the notification
 * was created — e.g. a dormant thread gets locked by backfill between when
 * the bell fetched it and when the user hits send). On 423, the composer
 * hides itself immediately rather than waiting for a refetch.
 */
import { ApiError } from '@discovr/common';

/** True when an error is an ApiError carrying HTTP 423 (thread locked). */
export function isThreadLockedError(err: unknown): boolean {
  return err instanceof ApiError && err.httpStatus === 423;
}
